export const footerLinks = [
  {
    title: "Work",
    link: "/work",
    isOutbound: false,
  },
  {
    title: "Contact",
    link: "/contact",
    isOutbound: false,
  },
  {
    title: "Bracket",
    url: "https://bracket.rawcolorstudios.com/",
    external: true,
  },
  {
    title: "Home",
    link: "/",
    isOutbound: false,
  },
  {
    title: "RCPS",
    url: "https://rcps.rawcolorstudios.com/",
    external: true,
  },
];
